const isSandbox = () => {
  if (
    typeof window === "undefined" ||
    !window.location ||
    !window.location.origin
  ) {
    return false
  }

  return (
    window.location.origin.includes("sandbox") ||
    window.location.origin.includes("localhost")
  )
}

const getInfoBaseUrl = () =>
  isSandbox() ? "https://cc-www.sandboxpga.org" : "https://pga.org"

/**
 * Resolves URLs for articles, returning either:
 * - The exact URL if it's already a full URL (http/https)
 * - A full URL built for articles hosted on CloudCannon, with domain based on environment
 *
 * Uses the domain for articles created in CloudCannon that are
 * deployed to pga.org (Prod) and cc-www.sandboxpga.org (Staging)
 *
 * Examples:
 *   resolveUrlForArticles('/membership/background-checks') => 'https://[cc-www.sandboxpga.org|pga.org]/membership/background-checks'
 *   resolveUrlForArticles('https://pga.com/more-information') => 'https://pga.com/more-information'
 */
export const resolveUrlForArticles = url => {
  if (!url) return ""

  // If already a full URL, use as-is
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url
  }

  // For relative paths, build full URL to info domain
  const path = url.startsWith("/") ? url : `/${url}`
  return `${getInfoBaseUrl()}${path}`
}

/**
 * Converts a career path name to a URL-friendly slug
 *
 * Examples:
 *   careerPathToSlug('Golf Operations') => 'golf-operations'
 *   careerPathToSlug('Teaching [&/and] Coaching') => 'teaching-coaching'
 *   careerPathToSlug('Executive Management') => 'executive-management'
 */
export const careerPathToSlug = careerPath => {
  if (!careerPath) return ""

  return careerPath
    .toLowerCase()
    .replace(/\s*&\s*/g, "-") // Replace ' & ' with '-'
    .replace(/\s+and\s+/g, "-") // Replace ' and ' with '-'
    .replace(/\s+/g, "-") // Replace remaining spaces with '-'
    .replace(/[^a-z0-9-]/g, "") // Remove any other special characters
    .replace(/-+/g, "-") // Collapse multiple dashes into one
}
